import React from "react"
import { Link } from "react-router-dom"

const MenuMobile = () => {
  return (
    <ul className="list">
      <li><Link to='/karir'>Find Your Path</Link></li>
      <li><Link to='/lowongan'>Internships</Link></li>
      <li><Link to='/'>Home</Link></li>
    </ul>
  )
}

export default MenuMobile
